(function () {
  'use strict';

  // Back-button scroll restoration.
  //
  // The browser restores the scroll offset itself, but it does so against the document as it is at
  // that instant. When a page finishes shorter than it was -- lazy images, an app's review widget,
  // or a collection whose "Load more" pages have not been rebuilt yet -- the restored offset lands
  // somewhere else, or gets clamped. This remembers where the customer actually was and re-applies
  // it while the page settles.
  //
  // Deliberately NOT touching history.scrollRestoration: the browser's own restore stays in charge
  // and this only supplements it, so a failure here leaves the default behaviour intact.

  if (window.__kjpScrollRestoreInit) return;
  window.__kjpScrollRestoreInit = true;

  var PREFIX = 'kjp:scroll:';
  var MAX_AGE = 30 * 60 * 1000; // A stale entry from an hour ago is not where the customer wants to be.
  var SETTLE_MS = 5000; // How long the page is given to finish settling.
  var AFTER_LOAD_MS = 1000; // Heavy pages finish loading after that window; hold a little longer.
  var TOLERANCE = 4; // Close enough, in px.

  function key() {
    return PREFIX + window.location.pathname + window.location.search;
  }

  // Private browsing throws on sessionStorage; never let that break the page.
  function read() {
    try {
      var raw = window.sessionStorage.getItem(key());
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function write(state) {
    try {
      window.sessionStorage.setItem(key(), JSON.stringify(state));
    } catch (error) {
      /* full, disabled, or private mode -- nothing to do */
    }
  }

  /**
   * Other scripts (the collection Load more) record their own state under the same entry, so read,
   * merge and write rather than overwriting.
   */
  window.kjpScrollState = {
    save: function (extra) {
      var state = read() || {};
      state.y = Math.round(window.scrollY || window.pageYOffset || 0);
      state.ts = Date.now();

      if (extra) {
        for (var prop in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, prop)) state[prop] = extra[prop];
        }
      }

      write(state);
    },
    read: function () {
      var state = read();
      if (!state || !state.ts || Date.now() - state.ts > MAX_AGE) return null;

      return state;
    },
    isBackForward: function () {
      try {
        var entry = (performance.getEntriesByType('navigation') || [])[0];
        return !!entry && entry.type === 'back_forward';
      } catch (error) {
        return false;
      }
    }
  };

  // "pagehide" fires for ordinary navigations AND when the page enters the back/forward cache.
  // "unload" would do the same job but disables bfcache outright -- which is the very thing that
  // makes Back work well when it is available.
  window.addEventListener('pagehide', function () {
    window.kjpScrollState.save();
  });

  if (!window.kjpScrollState.isBackForward()) return;

  var saved = window.kjpScrollState.read();
  if (!saved || !saved.y) return;

  var target = saved.y;
  var deadline = Date.now() + SETTLE_MS;
  var cancelled = false;

  var INPUT_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown', 'pointerdown'];

  function stop() {
    if (cancelled) return;
    cancelled = true;
    INPUT_EVENTS.forEach(function (type) {
      window.removeEventListener(type, onUserInput);
    });
  }

  // The customer's own scrolling always wins. Cancel on real input only, never on the scroll event
  // itself: the browser's own restoration fires asynchronously and would otherwise look like the
  // customer scrolling, cancelling the correction just before it was needed.
  function onUserInput() {
    stop();
  }

  INPUT_EVENTS.forEach(function (type) {
    window.addEventListener(type, onUserInput, { passive: true });
  });

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  function apply() {
    if (cancelled) return;

    var reachable = Math.min(target, maxScroll());
    if (Math.abs((window.scrollY || 0) - reachable) <= TOLERANCE) return;

    window.scrollTo(0, reachable);
  }

  function tick() {
    if (cancelled) return;

    apply();

    // Hold for the whole settle window rather than stopping as soon as the offset is reachable:
    // the browser's own restoration lands asynchronously and can arrive after the page has grown,
    // putting the customer back in the wrong place. apply() is a no-op once we are on target, so
    // this costs nothing. The collection rebuild flags itself on <html> and extends the window.
    var rebuilding = document.documentElement.hasAttribute('data-kjp-restoring');

    if (Date.now() < deadline || rebuilding) {
      window.requestAnimationFrame(tick);
      return;
    }

    stop();
  }

  // On a heavy page (apps, lazy media) the browser's own restoration can land after the settle
  // window has closed, so hold a little past the load event too.
  window.addEventListener('load', function () {
    if (cancelled) return;

    deadline = Math.max(deadline, Date.now() + AFTER_LOAD_MS);
    tick();
  });

  if (document.readyState === 'complete') {
    tick();
  } else {
    window.requestAnimationFrame(tick);
  }
})();
